import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '@/components/feature/Footer';

/**
 * 全局 BaseLayout 通用路由布局组件
 * 统一控制页面外层 min-h-screen flex flex-col 弹性贴底容器
 * 并在路由级别统管 Footer 的渲染，避免在每个单独页面中写 <Footer />
 */
export const BaseLayout: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <main className="flex-1 flex flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default BaseLayout;
